import script from "./PaWorkspace.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaWorkspace.vue?vue&type=script&setup=true&lang=ts"

import "./PaWorkspace.vue?vue&type=style&index=0&id=66318128&lang=scss&scoped=true"
import "./PaWorkspace.vue?vue&type=style&index=1&id=66318128&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66318128"]])

export default __exports__